import React, { useState, useEffect } from "react";
import { Button, Card, Dropdown, Modal, Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { HiUserAdd, HiOutlineChevronDown } from "react-icons/hi";
import AppControl from "../../../components";
import {
  getAssociates,
  deleteAssociate,
} from "../../../store/slice/associates";

function Associate() {
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAssociates());
  }, []);

  const associateList = useSelector((state) => state.associates.list);

  const showDeleteConfirm = (row) => {
    setModalText(`Are you sure you want to delete ${row.firstName}?`);
    setOpen(true);
    setDeleteId(row.id);
  };

  const handleOk = async () => {
    setConfirmLoading(true);
    const resultAction = await dispatch(deleteAssociate(deleteId));
    if (deleteAssociate.fulfilled.match(resultAction)) {
      setOpen(false);
      setConfirmLoading(false);
      Modal.success({ content: resultAction.payload.message });
    } else {
      setOpen(false);
      setConfirmLoading(false);
      Modal.error({ content: resultAction.error.message });
    }
  };

  const handleCancel = () => setOpen(false);

  const COLUMNS = [
    { Header: "Id", accessor: "id", isVisible: false, disableFilters: true },
    { Header: "Email", accessor: "user.email", disableFilters: true },
    { Header: "First Name", accessor: "user.firstName" },
    { Header: "Last Name", accessor: "user.lastName", disableFilters: true },
    {
      Header: "Phone Number",
      accessor: "user.phoneNumber",
      disableFilters: true,
    },
    { Header: "Gender", accessor: "gender", disableFilters: true },
    { Header: "State", accessor: "state" },
    { Header: "District", accessor: "district" },
    {
      Header: "Primary Work Area",
      accessor: "primaryWorkAreaPinCode",
      disableFilters: true,
    },
    {
      Header: "Payment Method",
      accessor: "preferredPaymentMethod",
      disableFilters: true,
    },
    { Header: "Active", accessor: "isActive", disableFilters: true },
    {
      Header: "Actions",
      disableFilters: true,
      Cell: ({ row }) => (
        <Dropdown
          menu={{
            items: [
              {
                key: "1",
                label: <Link to={`details/${row.values.id}`}>View</Link>,
              },
              {
                key: "2",
                label: <Link to={`edit/${row.values.id}`}>Edit</Link>,
              },
              {
                key: "3",
                danger: true,
                label: (
                  <span onClick={() => showDeleteConfirm(row.values)}>
                    Delete
                  </span>
                ),
              },
            ],
          }}
        >
          <Button>
            <Space>
              Actions <HiOutlineChevronDown />
            </Space>
          </Button>
        </Dropdown>
      ),
    },
  ];

  return (
    <Card
      title="ASSOCIATE LIST"
      extra={
        <AppControl
          control="button"
          type="reset"
          name="Add New Associate"
          size="full"
          color="orange"
          icon={<HiUserAdd size="1.25em" className="inline mr-1" />}
          onClick={() => navigate("/associates/add")}
        />
      }
    >
      <AppControl control="table" columns={COLUMNS} data={associateList} />
      <Modal
        title="Delete"
        open={open}
        okText="Yes, Delete!"
        okType="danger"
        onOk={handleOk}
        confirmLoading={confirmLoading}
        cancelText="No, Cancel"
        onCancel={handleCancel}
      >
        <p>{modalText}</p>
      </Modal>
    </Card>
  );
}

export default Associate;
